<template lang="pug">
  router-view
</template>

<script>
import axios from 'axios'
import Store from './store/index.js'
import 'intro.js/introjs.css';
import 'intro.js/themes/introjs-modern.css';
import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Version from './version';

switch (Version.data().cuonaManagerEnvironment) {
  case 'bleeding-edge':
  case 'staging':
  case 'production':
    Sentry.init({
      dsn: 'https://f6f92a68df9c4f39b04a882bd8ff09f3@sentry.io/1875640',
      integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
      environment: Version.data().cuonaManagerEnvironment,
      release: Version.data().cuonaManagerVersion,
      beforeSend(event) {
        if (Store && Store.state && Store.state.user && Store.state.user.user) {
          if (!event.user) {
            event.user = {}
          }
          event.user.id = Store.state.user.user.id;
          event.user.email = Store.state.user.user.email;
        }
      }
    });
    break;
}

export default {
  name: 'App',
  store: Store,
  computed: {
    locale () {
      return this.$store.state.global.setting.locale;
    }
  },
  created() {
    this.$i18n.locale = this.locale
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300');

body {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
}

a {
  text-decoration: none;
}

.el-main {
  position: relative;
  background: #F9F9F9;
}

.content {
  background: #FFF;
  margin: 40px;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 6px;
}

.highlightBg {
  background-color: rgba(255, 233, 0, 0.3);
}

</style>
